<template>
  <date-pick
    class="form-datetime"
    :value="value"
    @input="sendDatetime"
    :pickTime="true"
    :displayFormat="displayFormat"
    :format="format"
    :parseDate="parseDate"
    :inputAttributes="inputAttributes"
    :months="months"
    :weekdays="weekdays"
    :nextMonthCaption="nextMonthCaption"
    :prevMonthCaption="prevMonthCaption"
    :setTimeCaption="setTimeCaption"/>
</template>

<script>
import DatePick from 'vue-date-pick'

export default {
  name: 'DatePicker',
  components: { DatePick },
  props: {
    value: String
  },
  data () {
    return {
      displayFormat: this.$t('datepicker.DISPLAY'),
      format: 'YYYY-MM-DD HH:mm',
      inputAttributes: { readonly: true, placeholder: this.$t('datepicker.PLACEHOLDER') },
      nextMonthCaption: this.$t('datepicker.NEXT_MONTH'),
      prevMonthCaption: this.$t('datepicker.PREV_MONTH'),
      setTimeCaption: this.$t('datepicker.TIME'),
      weekdays: this.$t('datepicker.WEEKDAYS'),
      months: this.$t('datepicker.MONTHS')
    }
  },
  methods: {
    parseDate (dateString) {
      return new Date(dateString)
    },
    sendDatetime (value) {
      const dt = value.length ? new Date(value).toISOString() : value
      this.$emit('input', dt)
    }
  }
}
</script>

<style lang="scss">

@import "~@/styles/base.scss";
$vdpColor: $main-medium;
@import '../../node_modules/vue-date-pick/src/vueDatePick.scss';

.form-datetime > input {
  @extend .form-input;
  margin: $input-margin;
  display: block;
  font-size: $form-font-size;
}

.vdpComponent {
  @extend .vdpComponent;
  display: block;
  width: 50%;
}

</style>
